import React from 'react';
import { useResponsive } from '@parsina/framework';

import LoginWeb from './Login.web.jsx';
import LoginMobile from './Login.mobile.jsx';

// ورود — two surfaces, ONE auth flow.
//
// This screen is rendered by App.jsx's gate when there is no usable token, and it
// exists instead of an immediate `redirectToLogin()` for a reason worth stating:
// an app that bounces to Keycloak on load has no frame in which to show
// `auth.loopError` when the redirect guard trips, and no page for a student who
// arrived from a bookmark to read before being thrown at an identity provider.
//
// The button is what starts the OIDC Authorization Code + PKCE flow, against the
// `parsina-student` client id baked in at build time (src/lib/auth.js). Nothing
// about that flow differs by surface — only the layout does.

const LoginScreen = (props) => {
  const { isMobile } = useResponsive();
  return isMobile ? <LoginMobile {...props} /> : <LoginWeb {...props} />;
};

export default LoginScreen;
